import { Box, IconButton, Tooltip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { buildAllianceQuickLinks } from "../utils/allianceQuickLinks";

export function AllianceQuickLinkIcons({ alliance }: { alliance: any }) {
  const theme = useTheme();
  const links = buildAllianceQuickLinks(alliance);
  if (links.length === 0) return null;

  return (
    <Box
      component="nav"
      aria-label="Brze poveznice"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.25,
        flexWrap: "wrap",
      }}
    >
      {links.map(({ key, href, ariaLabel, Icon }) => {
        const openBlank = /^https?:\/\//i.test(href);
        return (
          <Tooltip key={key} title={ariaLabel}>
            <IconButton
              component="a"
              href={href}
              {...(openBlank
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              size="small"
              aria-label={ariaLabel}
              sx={{
                width: 30,
                height: 30,
                p: 0.375,
                color: "text.secondary",
                "&:hover": {
                  color: "secondary.main",
                  bgcolor: alpha(theme.palette.secondary.main, 0.08),
                },
              }}
            >
              <Icon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
}
